<template>
  <section class="external-menu__section__wrapper">
    <cpf-collection />
    <div>
      <chat-twilio-conversations v-if="isChatTwilioConversationsFlagEnabled" />
      <chat-twilio v-else />
    </div>
    <div class="external-menu__section">
      <template v-for="(item, index) in menuItems">
        <jade-tooltip
          v-if="item.conditional"
          class="external-menu__itens"
          :text="$t(item.label)"
          placement="top"
          :key="index + item.id"
          :id="item.id"
          :data-testid="item.id"
        >
          <jade-action-button
            :active="item.active"
            :icon="item.icon"
            @click="handleClick(item)"
          />
        </jade-tooltip>
      </template>
    </div>
  </section>
</template>

<script>
import { isChatTwilioConversationsFlagEnabled } from '../../../../../feature-flags/chat-twilio-conversations.feature-flags'

import { mapGetters, mapActions } from 'vuex'

import { isGateway } from '@/enums/business-model.enum'
import shopEnabled from '@/actions-permission/shop.permissions'

import EXTERNAL_FOOTER from './items/menu-footer.menu'

import { JadeActionButton, JadeTooltip } from '@/components/jade'
import '@pagarme/chat-twilio/web-comp'
import '@pagarme/chat-twilio-conversations/web-comp'
import '@pagarme/cpf-collection/web-comp'

export default {
  name: 'AppMenuFooter',
  components: {
    JadeActionButton,
    JadeTooltip
  },
  data () {
    return {
      isChatTwilioConversationsFlagEnabled: false
    }
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
    merchantId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'account',
      'componentIsEnabled',
      'permissionIsEnabled',
      'hasShopUnavailable',
      'gatewaySettings',
      'GET_DRAWER_HELP_CENTER',
      'GET_DRAWER_FEES_CALCULATOR'
    ]),
    chatTwilioConversationsEnabled () {
      return this.isChatTwilioConversationsFlagEnabled
    },
    menuItems () {
      return EXTERNAL_FOOTER({
        merchantId: this.merchantId,
        accountId: this.accountId,
        componentIsEnabled: this.componentIsEnabled,
        permissionIsEnabled: this.permissionIsEnabled,
        shop: {
          conditional: shopEnabled(
            this.permissionIsEnabled,
            this.componentIsEnabled,
            this.hasShopUnavailable
          )
        },
        simulator: {
          actionToggleDrawer: this.TOGGLE_DRAWER_FEES_CALCULATOR,
          getToggleDrawer: this.GET_DRAWER_FEES_CALCULATOR,
          conditional: !isGateway(this.account?.business_model)
        }
      })
    }
  },
  methods: {
    ...mapActions([
      'TOGGLE_DRAWER_HELP_CENTER',
      'TOGGLE_DRAWER_FEES_CALCULATOR'
    ]),
    handleClick (item) {
      if (item.click && typeof item.click === 'function') {
        item.click()
      }
    }
  },
  async mounted () {
    this.isChatTwilioConversationsFlagEnabled =
      await isChatTwilioConversationsFlagEnabled()
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "sidemenu": {
        "external": {
          "hub": "Hub",
          "shop": "Shop",
          "help_center": "Ajuda",
          "simulator": "Simulador de vendas"
        }
      }
    },
    "en-US": {
      "sidemenu": {
        "external": {
          "hub": "Hub",
          "shop": "Shop",
          "help_center": "HELP",
          "simulator": "Sales simulator"
        }
      }
    }
  }
</i18n>

<style scoped>
@import './app-menu.css';

.external-menu__section__wrapper {
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-top: 1px solid var(--gray-50-squanchy);
  gap: 12px;
}

.external-menu__section {
  display: flex;
  gap: 8px;
}
.external-menu__itens {
  width: 100%;
}
</style>
